var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import api from '@utils/axios';
import { inspectionAssistantInsightsAnalyticReportsPath } from '@routes';
import mapper from './mapper';
export default function getInspectionAssistantInsights(filters) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const url = inspectionAssistantInsightsAnalyticReportsPath({
                startDate: filters.values.dateRange.startDate,
                endDate: filters.values.dateRange.endDate
            });
            const response = yield api.get(url, {
                headers: {
                    Accept: 'application/json'
                }
            });
            return mapper(response.data);
        }
        catch (error) {
            console.error('Error getting inspection assistant insights:', error);
            throw error;
        }
    });
}
